import type { SVGProps } from 'react';

type SvgIconProps = SVGProps<SVGSVGElement> & {
  iconId: string;
};

/** CUBA Theme SVG sprite helper — symbols live in /svg/sprite.svg */
export function SvgIcon({ iconId, ...rest }: SvgIconProps) {
  return (
    <svg {...rest}>
      <use href={`/svg/sprite.svg#${iconId}`} />
    </svg>
  );
}
